<div [ngClass]="{'page-background': useRebrandedLayout }">
  <div *ngIf="!useRebrandedLayout" class="hero">
    <div class="hero-overlay"></div>
    <div class="hero-content d-flex">
      <div class="container d-flex flex-row">
        <div class="hero-content-text align-self-center">
          <h1>
            <span class="fw-light">My account</span>
            <br />
          </h1>
        </div>
      </div>
    </div>
  </div>

  <div class="container pt-4">
    <ngb-alert
      *ngIf="alert"
      [type]="alert.type"
      (closed)="closeAlert()"
      class="sticky-top"
      style="top: 10px"
    >
      {{ alert.message }}
    </ngb-alert>

    <ngb-alert
      *ngIf="upgradeNoPetAlert"
      [type]="'info'"
      (closed)="closeAlert()"
      class="sticky-top"
      style="top: 10px"
    >
      To upgrade your account you need to
      <a [routerLink]="['/claim-pet']"><strong>add a pet</strong></a>
      first.
    </ngb-alert>

    <div class="row mb-5">
      <div class="col-12">
        <h1 *ngIf="useRebrandedLayout" class="page-title text-center mt-4">
          My account
        </h1>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-12 col-md-4">
        <h6 [ngClass]="{'page-title': useRebrandedLayout }">Personal details</h6>
      </div>

      <div class="col-12 col-md-8 card border-0">
        <div class="mt-3 mb-3">
          <div class="row mb-2">
            <div class="col-12 col-md-8">
              {{ user.title ? user.title : '' }} {{ user.name.firstName }}
              {{ user.name.lastName }}
            </div>
            <div
              class="col-12 col-md-4"
              *ngIf="
                !(
                  user.productType === productType.Locator ||
                  user.productType === productType.Premium ||
                  user.productType === productType.LegacyPremium ||
                  user.productType === productType.LegacyPlus
                )
              "
            >
              &nbsp;
            </div>
            <div
              class="col-12 col-md-4"
              *ngIf="
                user.productType === productType.Locator ||
                user.productType === productType.Premium ||
                user.productType === productType.LegacyPremium ||
                user.productType === productType.LegacyPlus
              "
            >
              <a routerLink="/account/update-title">Update title</a>
            </div>
          </div>

          <div class="row mb-2" *appFeatureFlag="'isChangeEmailAddressAvailable'">
            <div class="col-12 col-md-8">
              {{ user.contact.email }}
            </div>
            <div class="col-12 col-md-4">
              <a
                [routerLink]="['/account/update-email']"
                (click)="trackEvent('accountdash::emailchange::clicked')"
              >
                Change email address
              </a>
            </div>
          </div>

          <div class="row mb-2" *appFeatureFlag="'isPasswordChangeActionAvailable'">
            <div class="col-12 col-md-8">Password ********</div>
            <div class="col-12 col-md-4">
              <a
                [routerLink]="['/account/update-password']"
                (click)="trackEvent('accountdash::pwchange::clicked')"
              >
                Change password
              </a>
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-12 col-md-8">Date of birth: {{ getDateOfBirth() }}</div>
            <div class="col-12 col-md-4">
              <a routerLink="/account/update-date-of-birth">Update date of birth</a>
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-12 col-md-8">Gender: {{ user.gender ? user.gender : '-' }}</div>
            <div class="col-12 col-md-4">
              <a routerLink="/account/update-gender">Update gender</a>
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-12 col-md-8">
              <div *ngIf="!user.contact.mainPhoneNumber && !user.contact.secondaryPhoneNumber" class="text-muted">
                Telephone number not provided yet.
              </div>

              <div *ngIf="user.contact.mainPhoneNumber" [ngClass]="user.contact.secondaryPhoneNumber && 'mb-2'">
                <span class="badge bg-primary">
                  Main
                </span>
                {{ user.contact.mainPhoneNumber }}
              </div>
              <div *ngIf="user.contact.secondaryPhoneNumber">
                <span class="badge bg-secondary">
                  Second
                </span>
                {{ user.contact.secondaryPhoneNumber }}
              </div>

            </div>
            <div class="col-12 col-md-4">
              <a
                *ngIf="
                  user.productType === productType.Locator ||
                  user.productType === productType.Premium ||
                  user.productType === productType.LegacyPremium ||
                  user.productType === productType.LegacyPlus ||
                  (!user.contact.mainPhoneNumber && !user.contact.secondaryPhoneNumber) ||
                  !user.addresses.length
                "
                routerLink="/account/update-telephone"
                (click)="trackEvent('accountdash::phonechange::clicked')"
              >
                Update phone number
              </a>
              <span
                *ngIf="
                  userService.isUserBasicOrBasicPlus(user.productType) &&
                  (user.contact.mainPhoneNumber || user.contact.secondaryPhoneNumber) &&
                  user.addresses.length
                "
              >
                <a
                  *ngIf="
                    user.detailsUpdatable || this.userService.isOlderThan14Days(this.user.created) || this.user.productType !== productType.Basic;
                    else mutedChangeDetails
                  "
                  [routerLink]="['/account/user-details']"
                  class="d-inline-block mb-2"
                >
                  Change my details
                </a>

                <ng-template #mutedChangeDetails>
                  <u class="text-muted" (click)="openUpdateDetailsModal()" style="cursor: pointer">
                    Change my details
                  </u>
                </ng-template>
              </span>
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-12 col-md-8"></div>
            <div class="col-12 col-md-4">
              <a type="button" [href]="updateCardLink">Edit card details</a>
            </div>
          </div>

          <div *ngIf="!user.addresses.length" class="row mb-2">
            <div class="col-12 col-md-8">
              <div class="text-muted">Address not provided yet.</div>
            </div>
            <div class="col-12 col-md-4">
              <a routerLink="/account/address/new" class="d-inline-block mb-2">Add address</a>
              <br />
            </div>
          </div>
          <div
            *ngFor="let address of user.addresses; let first = first"
            [ngClass]="{ 'mb-2': first }"
            class="row"
          >
            <div class="col-12">
              <hr class="my-2" />
            </div>
            <div class="col-12 col-md-8">
              <div>{{ address.line1 }}</div>
              <div *ngIf="address.line2">{{ address.line2 }}</div>
              <div>{{ address.town }}</div>
              <div>{{ address.county }}</div>
              <div>{{ address.postcode }}</div>
            </div>
            <div class="col-12 col-md-4">
              <a
                *ngIf="
                  user.productType === productType.Locator ||
                  user.productType === productType.Premium ||
                  user.productType === productType.LegacyPremium ||
                  user.productType === productType.LegacyPlus ||
                  (user.productType === productType.BasicPlus && basePlusCanAddAndEditSecoundAddress) ||
                  (!user.contact.mainPhoneNumber?.trim() && !user.contact.secondaryPhoneNumber?.trim())
                "
                [routerLink]="['/account/address', address.id, 'edit']"
                (click)="trackEvent('accountdash::' + (first ? '' : '2nd') + 'addresschange::clicked')"
                class="d-inline-block mb-2"
              >
                Update address
              </a>
            </div>
          </div>
          <div
            *ngIf="
              user.addresses.length === 1 &&
              (user.productType === productType.Locator ||
                user.productType === productType.Premium ||
                user.productType === productType.LegacyPremium ||
                user.productType === productType.LegacyPlus ||
                (user.productType === productType.BasicPlus && basePlusCanAddAndEditSecoundAddress) )
            "
            class="row mb-2"
          >
            <div class="col-12 col-md-4 offset-md-8">
              <a routerLink="/account/address/new" class="d-inline-block mb-2">Add second address</a>
              <br />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-3 justify-content-center">
      <div *ngIf="showCardExpirationBox">
        <div class="d-flex card-warning-box">
          <div class="d-flex align-item-center justify-content-center">
            <img
              class="card-warning-box__icon"
              src="/assets/images/home/info-icon.svg"
              alt="info-svg"
            />
          </div>
          <div class="card-warning-box__text align-item-center justify-content-center">
            {{ isExpiringThisMonth ? 'Your card is due to expire' : 'Your card has expired' }}
            . Please
            <a [href]="updateCardLink">click here</a>
            to update your card details.
          </div>
        </div>
      </div>
    </div>

    <hr class="my-4" />

    <div class="row mb-3">
      <div class="col-12 col-md-4">
        <h6 [ngClass]="{'page-title': useRebrandedLayout }">Account type</h6>
      </div>

      <div [ngSwitch]="user.originalProductType" class="col-12 col-md-8 card border-0 py-2">
        <div *ngSwitchCase="productType.Basic" class="row mb-3 mt-3">
          <div class="col-12 col-md-8">
            <span class="badge bg-primary">Basic</span>
          </div>
          <div class="col-12 col-md-4">
            <a
              *ngIf="user.pets.length"
              routerLink="/account/account-type"
              (click)="trackEvent('accountdash::upgradeaccount::clicked')"
            >
              Upgrade
            </a>
            <button
              *ngIf="!user.pets.length"
              class="btn btn-link p-0"
              type="button"
              (click)="closeAlert(); upgradeNoPetAlert = true"
            >
              Upgrade
            </button>
          </div>
        </div>

        <div *ngSwitchCase="productType.BasicPlus" class="row">
          <div class="col-12 col-md-8">
            <span class="badge custom-badge">
              <h5 class="fw-bold text-primary mb-0">{{ plan1Name }}</h5>
            </span>
          </div>
          <div class="col-12 col-md-4"></div>
        </div>

        <div *ngSwitchCase="productType.Premium" class="row">
          <div class="col-12 col-md-8">
            <span class="badge custom-badge">
              <h5 class="fw-bold text-primary mb-0">{{ plan2Name }}</h5>
            </span>
          </div>
          <div class="col-12 col-md-4"></div>
        </div>

        <div *ngSwitchCase="productType.LegacyPremium" class="row">
          <div class="col-12 col-md-8">
            <span class="badge bg-primary">Premium</span>
          </div>
          <div class="col-12 col-md-4"></div>
        </div>

        <div *ngSwitchCase="productType.LegacyPlus" class="row">
          <div class="col-12 col-md-8">
            <span class="badge bg-primary">Plus</span>
          </div>
          <div class="col-12 col-md-4">
            <a *ngIf="user.pets.length" routerLink="/account/account-type">Upgrade</a>
            <button
              *ngIf="!user.pets.length"
              class="btn btn-link p-0"
              type="button"
              (click)="closeAlert(); upgradeNoPetAlert = true"
            >
              Upgrade
            </button>
          </div>
        </div>

        <div *ngSwitchCase="productType.Locator">
          <span class="badge bg-primary h5 fs-5 mb-0">{{ plan3Name }}</span>
        </div>

        <div *ngSwitchDefault class="row">
          <div class="col-12 col-md-8">
            <span class="badge bg-light">Not available</span>
          </div>
        </div>
      </div>
    </div>

    <hr class="my-4" />

    <div class="row mb-3">
      <div class="col-12 col-md-4">
        <h6 [ngClass]="{'page-title': useRebrandedLayout }">Invoices</h6>
      </div>

      <div class="col-12 col-md-8">
        <app-invoices
          [displayMyInvoicesImage]="false"
          [maxNrOfDisplayedPaidInvoices]="3"
        ></app-invoices>
      </div>
    </div>

    <hr class="my-4" />

    <div id="communicationPreferencesSection" class="row mb-3">
      <div class="col-12 col-md-4">
        <h6 [ngClass]="{'page-title': useRebrandedLayout }">Communication preferences</h6>
      </div>

      <div class="col-12 col-md-8">
        <div ngbAccordion [closeOthers]="false">
          <div ngbAccordionItem [collapsed]="false">
            <div ngbAccordionHeader>
              <div ngbAccordionCollapse class="card border-0">
                <div class="card-header">
                  <p>
                    <strong>Transactional</strong>
                  </p>
                  <p>
                    We promise we won't spam you, but from time to time we need to contact you with
                    important transactional emails such as changes to your account, security, resetting
                    your password.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div ngbAccordionItem [collapsed]="false">
            <div ngbAccordionHeader>
              <div ngbAccordionCollapse class="card border-0">
                <div class="card-header">
                  <p>
                    <strong>News & Updates</strong>
                  </p>
                  <p>
                    We would love to keep you up to date with all our latest news, offers, useful pet tips
                    and pet related content. Tick the boxes if you
                    <strong>do not want</strong>
                    to be contacted.
                  </p>
                  <div class="d-flex flex-column align-items-start idb-checkboxes-wrapper">
                    <div>
                      <mat-checkbox
                        name="email"
                        [(ngModel)]="communicationPreferences.emailChecked"
                        (change)="openReverseModal('emailChecked', $event)"
                      >
                        Email
                      </mat-checkbox>
                    </div>
                    <div>
                      <mat-checkbox
                        name="sms"
                        [(ngModel)]="communicationPreferences.smsChecked"
                        (change)="openReverseModal('smsChecked', $event)"
                      >
                        Text
                      </mat-checkbox>
                    </div>
                    <div>
                      <mat-checkbox
                        name="telephone"
                        [(ngModel)]="communicationPreferences.telephoneChecked"
                        (change)="openReverseModal('telephoneChecked', $event)"
                      >
                        Telephone
                      </mat-checkbox>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div ngbAccordionItem [collapsed]="false">
            <div ngbAccordionHeader>
              <div ngbAccordionCollapse class="card border-0">
                <div class="card-header">
                  <p>
                    <strong>Third Party Communications</strong>
                  </p>
                  <p>
                    We have partnered with carefully selected 3rd parties so that we can send you
                    exclusive offers and promotions on pet food, pet accessories, pet insurance and other
                    pet related services by email and SMS. We do not pass on your personal data to any 3rd
                    parties.
                  </p>
                  <p>
                    Tick here if you
                    <strong>do want</strong>
                    to receive this by
                  </p>
                  <div class="d-flex flex-column align-items-start idb-checkboxes-wrapper">
                    <div>
                      <mat-checkbox
                        name="email"
                        [(ngModel)]="user.communicationPreferences.thirdPartyCommunicationEmail"
                        (change)="openModal('thirdPartyCommunicationEmail', $event)"
                      >
                        Email
                      </mat-checkbox>
                    </div>
                    <div>
                      <mat-checkbox
                        name="sms"
                        [(ngModel)]="user.communicationPreferences.thirdPartyCommunicationSms"
                        (change)="openModal('thirdPartyCommunicationSms', $event)"
                      >
                        Text
                      </mat-checkbox>
                    </div>
                  </div>
                  <p>
                    Tick here if you
                    <strong>do not want</strong>
                    to receive this by
                  </p>
                  <div class="d-flex flex-column align-items-start idb-checkboxes-wrapper">
                    <div>
                      <mat-checkbox
                        name="email"
                        [(ngModel)]="user.communicationPreferences.inverseThirdPartyCommunicationEmail"
                        (change)="openReverseModal('inverseThirdPartyCommunicationEmail', $event, true)"
                      >
                        Email
                      </mat-checkbox>
                    </div>
                    <div>
                      <mat-checkbox
                        name="sms"
                        [(ngModel)]="user.communicationPreferences.inverseThirdPartyCommunicationSms"
                        (change)="openReverseModal('inverseThirdPartyCommunicationSms', $event, true)"
                      >
                        Text
                      </mat-checkbox>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-1">
      <div class="col-12 col-md-8 offset-md-4">
        For more information about how we process your personal data, please visit our privacy notice
        <a routerLink="/privacy">here</a>
        .
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-12 col-md-8 offset-md-4">
        To access our terms and conditions,
        <a routerLink="/terms-and-conditions">click here</a>
        .
      </div>
    </div>

    <hr class="my-4" />

    <div class="row pb-3">
      <div class="col-md-4 offset-md-4 mb-3">
        <button
          type="button"
          class="btn text-white btn-lg w-100"
          [ngClass]="useRebrandedLayout ? 'btn-secondary' : 'btn-success'"
          (click)="save()"
          [disabled]="loading"
        >
          <fa-icon *ngIf="loading" [icon]="['fas', 'spinner']" [animation]="'spin'" class="me-3"></fa-icon>
          {{ loading ? 'Saving' : 'Save' }}
        </button>
      </div>
    </div>
  </div>
</div>